import { render, staticRenderFns } from "./generalTab.vue?vue&type=template&id=78f0e266&scoped=true&"
import script from "./generalTab.vue?vue&type=script&lang=js&"
export * from "./generalTab.vue?vue&type=script&lang=js&"
import style0 from "./generalTab.vue?vue&type=style&index=0&id=78f0e266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0e266",
  null
  
)

export default component.exports